module.exports = __webpack_public_path__ + "static/18-3a64d992ee0c00791466cdba896f57aa.jpg";